<template>
  <v-card>
    <v-img v-if="showImage" :src="featuredImg" height="200px">
      <v-spacer></v-spacer>
      <v-btn fab small>
        <v-icon @click="onEdit" :disabled="viewOnly">edit</v-icon>
      </v-btn>
    </v-img>
    <v-img v-else>
      <v-spacer></v-spacer>
      <v-btn fab small :disabled="viewOnly">
        <v-icon @click="onEdit">edit</v-icon>
      </v-btn>
    </v-img>
    <v-card-title primary-title>
      <div>
        <h3 class="mb-0">{{ item.name }}</h3>
        <div v-html="item.description"></div>
      </div>
    </v-card-title>

    <v-card-actions> </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ContentItem",
  props: {
    item: {
      type: Object,
    },
    showImage: {
      type: Boolean,
      default: true,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editedContent: null,
    };
  },

  computed: {
    featuredImg() {
      let img = "https://cdn.vuetifyjs.com/images/cards/desert.jpg";
      return this.item.imgURL != "" ? this.item.imgURL : img;
    },
  },
  methods: {
    onEdit() {
      //console.log('content edit', this.item);
      this.$emit("editContent", this.item);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/ContentItem.vue